import  { useState } from 'react';
import { Form, Input, Button, Card, Typography, message, Layout } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import useAuthApis from '../apis/useAuthApis';

const { Title } = Typography;
const { Content } = Layout;

const ForgotPassword = () => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const { forgetPasswordApi } = useAuthApis();

  const onFinish = async (values) => {
    setLoading(true);
    const res = await forgetPasswordApi(values);
    if (res.error) {
      message.error(res.message || 'Invalid email');
      setLoading(false);
    } else {
      message.success('Password reset link sent to your email.');
      form.resetFields();
      setLoading(false);
    }
  };

  return (
    <Layout style={{ minHeight: '100vh', background: '#f0f2f5' }}>
      <Content style={{ 
        width: '100%', 
        maxWidth: '400px', 
        margin: '0 auto', 
        marginTop: '10vh' 
      }}>
        <Card style={{ boxShadow: '0 1px 3px rgba(0,0,0,0.12)' }}>
          <div style={{ textAlign: 'center', marginBottom: '30px' }}>
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/fa/Seal_of_Uttar_Pradesh.svg/478px-Seal_of_Uttar_Pradesh.svg.png"
              alt="UP Logo"
              style={{
                height: '80px',
                marginBottom: '20px'
              }}
            />
            <Title level={2} style={{ margin: 0 }}>
            UP Municipal Admin
            </Title>
            <Title level={4} style={{ margin: 0, fontWeight: 'normal', color: 'rgba(0, 0, 0, 0.45)' }}>
            Forgot Password
            </Title>
          </div>

          <Form
            form={form}
            name="forgot-password"
            onFinish={onFinish}
            autoComplete="off"
            layout="vertical"
          >
            <Form.Item
              name="email"
              rules={[
                { required: true, message: 'Please input your email!' },
                { type: 'email', message: 'Please enter a valid email!' }
              ]}
            >
              <Input 
                prefix={<UserOutlined />} 
                placeholder="Email" 
                size="large" 
                maxLength={50}
              />
            </Form.Item>

            <Form.Item>
              <Button 
                type="primary" 
                htmlType="submit" 
                block 
                size="large"
                loading={loading}
              >
                Send Reset Link
              </Button>
            </Form.Item>
            <div style={{ textAlign: 'center', marginTop: '10px' }}>
              <Link to="/login" style={{ marginRight: '10px' }}>
                Back to Login
              </Link>
            </div>
          </Form>
        </Card>
      </Content>
    </Layout>
  );
};

export default ForgotPassword; 